import { Route } from '@angular/router';
import { authGuard, authRoutes } from '@brightside/core/auth';
import { BrightaiRoutes } from '@brighthub/brightai';

export const appRoutes: Route[] = [
  authRoutes,
  ...BrightaiRoutes,
  {
    path: 'dashboard',
    redirectTo: '../brightai',
  },
  {
    path: '**',
    pathMatch: 'prefix',
    redirectTo: 'brightai',
  },
];
